import * as z from "zod/v4";

export const createReplenishmentRequestViewFolder = {
  name: "createReplenishmentRequestViewFolder" as const,
  input: z.object({ name: z.string() }),
  output: z.object({ folderId: z.string() }),
};
